import { render, staticRenderFns } from "./search.component.vue?vue&type=template&id=e2773482&"
import script from "./search.component.vue?vue&type=script&lang=js&"
export * from "./search.component.vue?vue&type=script&lang=js&"
import style0 from "./search.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports